export const articleCodeMap: { [key: string]: string } = {
  '101': 'Н10',
  '102': 'Н11',
  '103': 'Н12',
  '104': 'Н93',
  '105': 'Н13',
  '106': 'Н94',
  '107': 'Н95',
  '108': 'Н14',
  '109': 'Н15',
  '110': 'Н16',
  '111': 'Н17',
  '112': 'Н18',
  '113': 'Н19',
  '114': 'Н20',
  '115': 'Н21',
  '116': 'Н22',
  '117': 'Н23',
  '118': 'Н96',
  '119': 'Н24',
  '120': 'Н97',
  '121': 'Н98',
  '122': 'Н25',
  '123': 'Н99',
  '124': 'Н100',
  '125': 'Н101',
  '126': 'Н26',
  '127': 'Н27',
  '128': 'Н102',
  '129': 'Н103',
  '130': 'Н28',
  '131': 'Н29',
  '132': 'Н30',
  '133': 'Н31',
  '134': 'Н32',
  '135': 'Н33',
  '136': 'Н104',
  '137': 'Н105',
  '138': 'Н106',
  '139': 'Н34',
  '140': 'Н107',
  '141': 'Н108',
  '142': 'Н109',
  '143': 'Н110',
  '144': 'Н35',
  '145': 'Н36',
  '146': 'Н37',
  '147': 'Н38',
  '148': 'Н39',
  '149': 'Н111',
  '150': 'Н112',
  '151': 'Н40',
  '152': 'Н113',
  '153': 'Н114',
  '154': 'Н115',
  '155': 'Н116',
  '156': 'Н41',
  '157': 'Н42',
  '158': 'Н43',
  '159': 'Н44',
  '160': 'Н45',
  '161': 'Н46',
  '162': 'Н47',
  '163': 'Н48',
  '164': 'Н49',
  '165': 'Н50',
  '166': 'Н51',
  '167': 'Н52',
  '168': 'Н53',
  '169': 'Н117',
  '170': 'Н118',
  '171': 'Н119',
  '172': 'Н120',
  '173': 'Н121',
  '174': 'Н122',
  '175': 'Н54',
  '176': 'Н55',
  '177': 'Н56',
  '178': 'Н57',
  '179': 'Н58',
  '180': 'Н123',
  '181': 'Н59',
  '182': 'Н124',
  '183': 'Н125',
  '184': 'Н60',
  '185': 'Н126',
  '186': 'Н127',
  '187': 'Н128',
  '188': 'Н129',
  '189': 'Н130',
  '190': 'Н131',
  '191': 'Н132',
  '192': 'Н133',
  '193': 'Н134',
  '194': 'Н135',
  '195': 'Н136',
  '196': 'Н137',
  '197': 'Н138',
  '198': 'Н61',
  '199': 'Н62',
  '200': 'Н63',
  '201': 'Н139',
  '202': 'Н140',
  '203': 'Н141',
  '204': 'Н142',
  '205': 'Н64',
  '206': 'Н65',
  '207': 'Н66',
  '208': 'Н143',
  '209': 'Н67',
  '210': 'Н68',
  '211': 'Н144',
  '212': 'Н145',
  '213': 'Н69',
  '214': 'Н146',
  '215': 'Н147',
  '216': 'Н148',
  '217': 'Н70',
  '218': 'Н149',
  '219': 'Н150',
  '220': 'Н151',
  '221': 'Н152',
  '222': 'Н71',
  '223': 'Н72',
  '224': 'Н153',
  '225': 'Н73',
  '226': 'Н74',
  '227': 'Н154',
  '228': 'Н75',
  '229': 'Н76',
  '230': 'Н155',
  '231': 'Н156',
  '232': 'Н157',
  '233': 'Н158',
  '234': 'Н159',
  '235': 'Н160',
  '236': 'Н161',
  '237': 'Н162',
  '238': 'Н163',
  '239': 'Н164',
  '240': 'Н165',
  '241': 'Н77',
  '242': 'Н78',
  '243': 'Н166',
  '244': 'Н167',
  '245': 'Н168',
  '246': 'Н79',
  '247': 'Н169',
  '248': 'Н170',
  '249': 'Н171',
  '250': 'Н172',
  '251': 'Н173',
  '252': 'Н174',
  '253': 'Н175',
  '254': 'Н176',
  '255': 'Н177',
  '256': 'Н80',
  '257': 'Н178',
  '258': 'Н179',
  '259': 'Н180',
  '260': 'Н81',
  '261': 'Н181',
  '262': 'Н182',
  '263': 'Н183',
  '264': 'Н82',
  '265': 'Н184',
  '266': 'Н185',
  '267': 'Н186',
  '268': 'Н187',
  '269': 'Н188',
  '270': 'Н189',
  '271': 'Н190',
  '272': 'Н191',
  '273': 'Н192',
  '274': 'Н193',
  '275': 'Н194',
  '276': 'Н195',
  '277': 'Н196',
  '278': 'Н197',
  '279': 'Н198',
  '280': 'Н199',
  '281': 'Н200',
  '282': 'Н201',
  '283': 'Н202',
  '284': 'Н203',
  '285': 'Н204',
  '286': 'Н83',
  '287': 'Н205',
  '288': 'Н206',
  '289': 'Н207',
  '290': 'Н84',
  '291': 'Н208',
  '292': 'Н209',
  '293': 'Н210',
  '294': 'Н211',
  '295': 'Н212',
  '296': 'Н213',
  '297': 'Н214',
  '298': 'Н215',
  '299': 'Н216',
  '300': 'Н217',
  '301': 'Н218',
  '302': 'Н219',
  '303': 'Н220',
  '304': 'Н221',
  '305': 'Н222',
  '306': 'Н223',
  '307': 'Н224',
  '308': 'Н225',
  '309': 'Н226',
  '310': 'Н227',
  '311': 'Н228',
  '312': 'Н229',
  '313': 'Н230',
  '314': 'Н231',
  '315': 'Н232',
  '316': 'Н85',
  '317': 'Н233',
  '318': 'Н234',
  '319': 'Н86',
  '320': 'Н235',
  '321': 'Н236',
  '322': 'Н88',
  '323': 'Н237',
  '324': 'Н238',
  '325': 'Н87',
  '326': 'Н239',
  '327': 'Н89',
  '328': 'Н90',
  '329': 'Н240',
  '330': 'Н91',
  '331': 'Н241',
  '332': 'Н242',
  '333': 'Н243',
  '334': 'Н244',
  '335': 'Н92',
  '336': 'Н245',
  '337': 'Н246',
  '338': 'Н247',
  '339': 'Н248',
  '340': 'Н249',
  '341': 'Н250',
  '342': 'Н251',
  '343': 'Н252',
  '344': 'Н253',
  '345': 'Н254',
  '346': 'Н255',
  '347': 'Н256',
  '348': 'Н257',
  '349': 'Н258',
  '350': 'Н259',
  '351': 'Н260',
  '352': 'Н261',
  '353': 'Н262',
  '354': 'Н263',
  '355': 'Н264',
  '356': 'Н265',
  '357': 'Н266',
  '358': 'Н267',
  '359': 'Н268',
  '360': 'Н269',
  '361': 'Н270',
}

export const defaultRiskyArticlesBefore1997 = ['103', '117', '210']

export const defaultRiskyArticlesAfter1997 = [
  '105',
  '106',
  '107',
  '108',
  '109',
  '110',
  '111',
  '112',
  '113',
  '114',
  '115',
  '116',
  '117',
  '118',
  '119',
  '126',
  '127',
  '131',
  '132',
  '133',
  '134',
  '135',
  '157',
  '158',
  '159',
  '160',
  '161',
  '162',
  '163',
  '166',
  '205',
  '209',
  '210',
  '213',
  '223',
  '228',
  '229',
  '230',
  '232',
  '242',
  '264',
  '290',
  '291',
  '327',
]
